import React from 'react'

import ChangePasswordForm from 'components/forms/profile/ChangePasswordForm'

const ChangePasswordModal = () => {
  return (
    <div className="modal-change-password">
      <div className="modal-header">
        <span className="modal-header-expiry"></span>
      </div>

      <ChangePasswordForm />
    </div>
  )
}

export default ChangePasswordModal
